export enum LocalStorageKeys {
    CurrentEmojiId = 'currentEmojiId',
    /**
     * Setup the redirects for the authentication flow
     */
    AuthRedirectType = 'authRedirectType',
    AuthRedirectPath = 'authRedirectPath',

    /**
     * This is used to inform us where was the entry point for the user
     * after a successful login (e.g. post auth redirect). This can be
     * used to idenfity how to deal with navigation if a user decides
     * to go back to the previous page.
     */
    AuthEntryPoint = 'authEntryPoint',

    DraftUserId = 'draftUserId',
    EmojiIds = 'emojiIds',
    OAuthLoggedIn = 'OAuthLoggedIn',
    RemoveDraftUser = 'removeDraftUser',
}

export enum LocalStorage2FAKeys {
    TimeSinceRequire = 'time_since_require_prompt',
    TimeSincePostPurchase = 'time_since_post_purchase_prompt',
}

export const localStorageKeys = {
    ...LocalStorageKeys,
    ...LocalStorage2FAKeys,
};
